import { render, staticRenderFns } from "./Chickin.vue?vue&type=template&id=63b3eb2c&"
import script from "./Chickin.vue?vue&type=script&lang=js&"
export * from "./Chickin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports